import { defineMessages } from 'react-intl';

export default defineMessages({
  fhnwTitle: {
    id: 'University of Applied Sciences and Arts Northwestern Switzerland',
    defaultMessage:
      'University of Applied Sciences and Arts Northwestern Switzerland',
  },
  AlternativeText: {
    id: 'Alternative Text',
    defaultMessage: 'Alternative Text',
  },
  Description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  Caption: {
    id: 'Image Caption',
    defaultMessage: 'Image Caption',
  },
  Format: {
    id: 'Format',
    defaultMessage: 'Format',
  },
  FocusPoint: {
    id: 'Focus point',
    defaultMessage: 'Focus point',
  },
  Float: {
    id: 'Float text around image',
    defaultMessage: 'Float text around image',
  },
  TabTitle: {
    defaultMessage: 'Tab title',
    id: 'tabTitle',
  },
  Title: {
    defaultMessage: 'Title',
    id: 'title',
  },
  HideTitle: {
    id: 'hideTitle',
    defaultMessage: 'Hide tab title?',
  },
  HideEmptyTabs: {
    id: 'hideEmptyTabs',
    defaultMessage: 'Hide empty tabs in view?',
  },
  toc: {
    id: 'toc',
    defaultMessage: 'Table of Contents',
  },
  Entries: {
    id: 'Entries',
    defaultMessage: 'Headings to be listed',
  },
  Enumeration: {
    id: 'Enumeration',
    defaultMessage: 'Enumeration',
  },
  Ordered: {
    id: 'NumberedList',
    defaultMessage: 'Numbered List',
  },
  Variant: {
    id: 'variant',
    defaultMessage: 'Variant',
  },
  hideHeaders: {
    id: 'Hide headers',
    defaultMessage: 'Hide header',
  },
  sortable: {
    id: 'Make the table sortable',
    defaultMessage: 'Sortable Table',
  },
  striped: {
    id: 'Stripe alternate rows with color',
    defaultMessage: 'Alternate row coloring',
  },
  table: {
    id: 'table',
    defaultMessage: 'Table',
  },
  visibleUntil: {
    id: 'visibleUntil',
    defaultMessage: 'Visible Until',
  },
  visibleFrom: {
    id: 'visibleFrom',
    defaultMessage: 'Visible From',
  },
  showOnMobile: {
    id: 'showOnMobile',
    defaultMessage: 'Show on mobile',
  },
  showOnDesktop: {
    id: 'showOnDesktop',
    defaultMessage: 'Show on Desktop',
  },
  ButtonBlock: {
    id: 'Button Block',
    defaultMessage: 'Button',
  },
  ButtonText: {
    id: 'ButtonText',
    defaultMessage: 'Button Text',
  },
  ButtonLink: {
    id: 'ButtonLink',
    defaultMessage: 'Button Link',
  },
  openLinkInNewTab: {
    id: 'Open link in new browser tab',
    defaultMessage: 'Open link in new browser tab',
  },
  column: {
    id: 'column',
    defaultMessage: 'column',
  },
  columns: {
    id: 'columns',
    defaultMessage: 'columns',
  },
  AddBlock: {
    id: 'addBlock',
    defaultMessage: 'Add a new block',
  },
  AddTab: {
    defaultMessage: 'Add Tab',
    id: 'addTab',
  },
  OpenDocumentInBrowser: {
    id: 'Open document in browser',
    defaultMessage: 'Open document in browser',
  },
  DownloadDocument: {
    id: 'Download document',
    defaultMessage: 'Download document',
  },
  iframe_view: {
    id: 'iframe_view',
    defaultMessage: 'Display as IFrame',
  },
  iframe_view_description: {
    id: 'iframe_view_description',
    defaultMessage:
      'Display the HTML snippet as an IFrame. This is useful for embedding external content.',
  },
  table_tab_column: {
    id: 'table_tab_column',
    defaultMessage: 'Columns',
  },
  table_caption: {
    id: 'table_caption',
    defaultMessage: 'Caption',
  },
  table_caption_description: {
    id: 'table_caption_description',
    defaultMessage: 'Optional caption for the table',
  },
  columnWidth: {
    id: 'column_width',
    defaultMessage: 'Width of column {columnNumber}',
  },
  columnWidthDescription: {
    id: 'column_width_description',
    defaultMessage: 'Enter width (e.g., 200px, 20%, auto)',
  },
  columnTextWrap: {
    id: 'column_text_wrap',
    defaultMessage: 'Allow line breaks for column {columnNumber}',
  },
  columnTextWrapDescription: {
    id: 'column_text_wrap_description',
    defaultMessage:
      'Deactivate the checkbox if you do not want to display line breaks in this column.',
  },
  SizeLarge: {
    id: 'SizeLarge',
    defaultMessage: 'Large',
  },
  SizeHalf: {
    id: 'SizeHalf',
    defaultMessage: 'Half',
  },
  SizeThird: {
    id: 'SizeThird',
    defaultMessage: 'Third',
  },
  SizePortrait: {
    id: 'SizePortrait',
    defaultMessage: 'Portrait',
  },
  SizeOriginal: {
    id: 'SizeOriginal',
    defaultMessage: 'Original',
  },
});
